import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { CarService } from 'src/app/services/car/car.service';
import { VisitService } from 'src/app/services/visit/visit.service';

@Component({
  selector: 'app-add-visit-new-car-modal',
  templateUrl: './add-visit-new-car-modal.component.html',
  styleUrls: ['./add-visit-new-car-modal.component.css']
})
export class AddVisitNewCarModalComponent implements OnInit {
  carSelect: any;
  cars = [];
  visitForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AddVisitNewCarModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private visitService: VisitService,
    private carService: CarService
  ) {
    this.createForm();
  }

  ngOnInit() {
    this.carService.getListEntity(this.data.idEntity).subscribe((response) => {
      if(response.error == null){
        this.cars = response.data;
      }else{
        this.cars = [];
      }
    },
      (error: HttpErrorResponse) => {
        this.cars = [];
      })
  }

  get f() {
    return this.visitForm.controls;
  }

  createForm(){
    this.visitForm = this.formBuilder.group({
      idCar: [0, [Validators.required]]
    });
  }

  changeCar(data) {
    var charselect = this.cars.filter(x => x.id == data.value)[0];
    this.carSelect = charselect;
  }

  save(){
    if(this.data.idVisit > 0){
      var payload = {
        idVisit: this.data.idVisit,
        idCar: this.carSelect.id,
        licensePlate: this.carSelect.licensePlate,
      };
      this.visitService.createVisitCar(payload).subscribe((response) => {
        if(response){
          this.data.id = response;
          this.dialogRef.close({car: this.carSelect});
        }else{

        }
      });
    }else{
      this.dialogRef.close({car: this.carSelect});
    }

  }

}
